import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants, { PurchaseFinishedResults, PurchaseTypes as paramPurchaseTypes } from '../../utils/routeParamConstants';
import Screens from '../index';
import PlayerInterface from '../../api/PlayerInterface';
import ShopInterface from '../../api/ShopInterface';
import { casinoIdStatus as PlayerStatus } from '../../api/PlayerInfoConstants';
import InboxMessagesProvider from '../../components/InboxMessagesProvider';
import store from '../../state/store';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});

var CurrencySelector = /*#__PURE__*/function (_Component) {
  _inherits(CurrencySelector, _Component);

  var _super = _createSuper(CurrencySelector);

  function CurrencySelector(props) {
    var _this;

    _classCallCheck(this, CurrencySelector);

    _this = _super.call(this, props);
    _this.state = {
      casinoDollarBalance: 0,
      package: '',
      offerDetail: null,
      purchaseType: '',
      serverResponse: '',
      message: null,
      purchaseInProgress: false,
      purchaseComplete: false
    };
    _this._getCasinoDollarBalance = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var casinoDollarBalance, rawResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return PlayerInterface.getCasinoDollarBalance();

            case 3:
              rawResponse = _context.sent;
              casinoDollarBalance = rawResponse[0].casinoDollarBalance;

              _this.setState({
                casinoDollarBalance: casinoDollarBalance
              });

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              _this.setState({
                serverResponse: _context.t0
              });

            case 11:
              return _context.abrupt("return", casinoDollarBalance);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    _this.purchaseHandler = function () {
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.PurchaseFlow));
    };

    _this.casinoDollarPurchaseHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var casinoDollarResponse;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this.state.purchaseInProgress) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _this.setState({
                purchaseInProgress: true,
                message: 'Please wait...'
              });

              _context2.next = 5;
              return _this._purchaseWithCasinoDollars();

            case 5:
              casinoDollarResponse = _context2.sent;

              if (casinoDollarResponse.success) {
                _this.setState({
                  purchaseComplete: true,
                  purchaseInProgress: false,
                  message: casinoDollarResponse.msg
                });

                QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.PurchaseSucceeded));

                if (_this.state.package && _this.state.package.OFFER_ID) {
                  try {
                    InboxMessagesProvider.removeMessage(_this.state.package.OFFER_ID);
                  } catch (e) {
                    console.error(e);
                  }
                }
              } else if (casinoDollarResponse.error) {
                _this.setState({
                  message: casinoDollarResponse.error,
                  serverResponse: casinoDollarResponse,
                  purchaseInProgress: false
                });

                _this.purchaseErrorRoute();
              } else {
                _this.purchaseErrorRoute();
              }

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this.purchaseErrorRoute = function () {
      var _QueryParamsProxy$set3;

      return QueryParamsProxy.setQueryParams((_QueryParamsProxy$set3 = {}, _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_MODAL, Screens.PurchaseFlow), _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_PURCHASE_FINISHED_RESULT, PurchaseFinishedResults.ERROR), _QueryParamsProxy$set3));
    };

    _this._purchaseWithCasinoDollars = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _store$getState$gameI;

      var casinoDollarResponse, active_game_id, trigger_id, _this$state$offerDeta, rawResponse;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              casinoDollarResponse = {};
              active_game_id = ((_store$getState$gameI = store.getState().gameInfo) === null || _store$getState$gameI === void 0 ? void 0 : _store$getState$gameI.gameId) || null;
              trigger_id = store.getState().purchase.actionTrigger;
              _context3.prev = 3;
              _context3.next = 6;
              return ShopInterface.purchaseWithCasinoDollars(_this.state.purchaseType, _this.state.package.CURRENCY_ITEM_ID || _this.state.package.item_id, (_this$state$offerDeta = _this.state.offerDetail) === null || _this$state$offerDeta === void 0 ? void 0 : _this$state$offerDeta.OFFER_ID, active_game_id, trigger_id);

            case 6:
              rawResponse = _context3.sent;
              casinoDollarResponse = rawResponse[0];
              _context3.next = 13;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](3);

              _this.setState({
                serverResponse: _context3.t0
              });

            case 13:
              return _context3.abrupt("return", casinoDollarResponse);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 10]]);
    }));
    _this.state.purchaseType = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_TYPE, null);
    _this.state.offerDetail = QueryParamsProxy.findParam(RouteParamConstants.PARAM_OFFER_DETAIL, null);
    var sku = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_SKU, null);

    if (_this.state.purchaseType == paramPurchaseTypes.VIP || _this.state.purchaseType == paramPurchaseTypes.CONSUMABLE) {
      var coinList = _this.props.shopList.vip;
      _this.state.package = coinList.find(function (item) {
        return item.item_id == sku;
      });
    } else if (_this.props.outOfCoinsPurchase) {
      var _coinList = _this.props.outOfCoinsOffer;
      _this.state.package = _coinList;
    } else if (_this.props.ltoPurchase) {
      var _coinList2 = _this.props.limitedTimeOffer;
      _this.state.package = _coinList2;
    } else if (_this.state.offerDetail) {
      _this.state.package = {
        AMOUNT: _this.state.offerDetail.amount,
        PRICE: _this.state.offerDetail.price,
        CURRENCY_ITEM_ID: _this.state.offerDetail.sku,
        OFFER_ID: _this.state.offerDetail.messageId
      };
    } else {
      var _coinList3 = _this.props.shopList.coins;
      _this.state.package = _coinList3.find(function (item) {
        return item.CURRENCY_ITEM_ID == sku;
      });
    }

    return _this;
  }

  _createClass(CurrencySelector, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this._getCasinoDollarBalance();
    }
  }, {
    key: "render",
    value: function render() {
      var coinPackage = this.state.package;
      var isPhysicallyVerified = this.props.casinoIdStatus === PlayerStatus.PHYSICALLY_VERIFIED;
      var cdPurchaseDisabledMessage = isPhysicallyVerified ? null : 'Only available to Star club members';
      var casinoDollarPurchaseDisabled = coinPackage && (+coinPackage.PRICE > +this.state.casinoDollarBalance || +coinPackage.price > +this.state.casinoDollarBalance);

      if (isPhysicallyVerified && casinoDollarPurchaseDisabled) {
        cdPurchaseDisabledMessage = 'Not enough Casino Dollars';
      }

      return this.props.render({
        casinoDollarBalance: format(this.state.casinoDollarBalance),
        cdPurchaseDisabledMessage: cdPurchaseDisabledMessage,
        casinoDollarPurchaseDisabled: casinoDollarPurchaseDisabled,
        purchaseHandler: this.purchaseHandler,
        casinoDollarPurchaseHandler: this.casinoDollarPurchaseHandler,
        message: this.state.message,
        purchaseComplete: this.state.purchaseComplete,
        isPhysicallyVerified: isPhysicallyVerified
      });
    }
  }]);

  return CurrencySelector;
}(Component);

export { CurrencySelector as default };